// src/components/TaskChat/hooks/useChatData.ts
import { useState, useEffect } from 'react';
import { useAuth } from '../../firebase/AuthProvider';
import UserInfo from '../../interfaces/UserInfo';
import Avatar from '../../interfaces/avatar/Avatar';
import { getAllUsersInOrganization } from '../../services/userServices/UserInfoService';
import { getAvatarsFromStorage } from '../../services/fileServices/FileService';

export const useChatData = () => {
  const { currentUser } = useAuth();
  const [users, setUsers] = useState<UserInfo[] | null>([]);
  const [avatars, setAvatars] = useState<Avatar[] | null>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      if (currentUser) {
        const token = await currentUser.getIdToken();
        const [fetchedUsers, storedAvatars] = await Promise.all([
          getAllUsersInOrganization(token),
          getAvatarsFromStorage()
        ]);
        setUsers(fetchedUsers);
        setAvatars(storedAvatars);
      }
      setIsLoading(false);
    };

    fetchData();
  }, [currentUser]);

  return { users, avatars, isLoading };
};